import React from 'react';

const LtiIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="LTI"
  >
    <rect width="24" height="24" rx="2" fill="none" />
    <text
      x="12"
      y="17"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="12"
      fontWeight="700"
      fill="var(--pgn-color-headings-base)"
    >
      LTI
    </text>
  </svg>
);

export default LtiIcon;
